import { Button, ButtonProps } from "@mui/material"

type SecondaryButtonProps = {
  label: string
} & ButtonProps

const SecondaryButton = ({ label, ...props }: SecondaryButtonProps) => {
  return (
    <Button
      variant="outlined"
      color="error"
      sx={{
        textTransform: "capitalize",
        borderRadius: "8px",
        fontWeight: "500",
        fontSize: "13px",
        padding: "11px 30px",
      }}
      {...props}
    >
      {label}
    </Button>
  )
}

export default SecondaryButton
